import { ResidenceOwnership, ResidenceProperty } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const ownershipTypeArray = Object.keys(ResidenceOwnership).map((status) => ({
  value: status.toLowerCase(),
  display: <Text tId={status.toLowerCase()} />,
}));

export const propertyTypeArray = Object.keys(ResidenceProperty).map((status) => ({
  value: status.toLowerCase(),
  display: <Text tId={status.toLowerCase()} />,
}));

export const mortgageTypeArray = [
  {
    value: true.toString(),
    display: <Text tId={'YES'} />,
  },
  {
    value: false.toString(),
    display: <Text tId={'NO'} />,
  },
];
